export default {
  global: {
    search: '搜索',
    confirm: '确定',
    reset: '重置',
    cancel: '取消'
  },
  map: {
    unknownLocation: '未知地点',
    selectLocation: '选中位置',
    address: '地址',
    lnglat: '经纬度'
  },
  treeTransfer: {
    itemUnit: '项'
  },
  upload: {
    uploadFiles: '上传文件',
    uploading: '文件上传中',
    uploadError: '上传错误',
    supportExtension: '支持扩展名',
    formatError: '上传文件格式不正确',
    limit: '单个附件大小不超过{num}M'
  }
}
